import './styles/Button.scss';

import { ButtonHTMLAttributes, PropsWithChildren } from 'react';

import { useClassHelper } from '../../../../hooks';

const componentName = 'w-Button';

interface Props
  extends PropsWithChildren,
    ButtonHTMLAttributes<HTMLButtonElement> {
  variants?: 'primary' | 'default';
}

export const Button = ({
  children,
  className,
  variants = 'primary',
  ...rest
}: Props) => {
  const c = useClassHelper(componentName);

  const btnClassName = c('base', ` ${className}`, {
    '--primary': variants === 'primary',
  });

  return (
    <button {...rest} className={btnClassName}>
      {children}
    </button>
  );
};
